import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import SecuritySection from "@/components/sections/SecuritySection";
import { Reveal } from "@/components/Reveal";
import { IMG } from "@/data/content";
import { site } from "@/config/site";

export default function About() {
  return (
    <>
      <Seo title="About HM Services | Hospitality Consultancy in Pakistan" description="Hospitality experience meets digital growth. Learn how HM Services and founder Hassan Ali help property owners strengthen their online presence." path="/about" image={IMG.reception} />
      <PageHero eyebrow="About Us" title="Hospitality Experience. Digital Growth. Better Results." subtitle="HM Services is a hospitality consultancy focused on helping hotels, guest houses, resorts, villas and property owners improve their online presence and grow their business." image={IMG.lobby} />

      <section className="bg-white py-24 lg:py-32" data-testid="about-content">
        <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:items-center">
          <Reveal>
            <div className="space-y-6 text-base leading-relaxed text-slate-600">
              <p>Today's guests often discover and compare properties online before making a booking. A property needs more than simply being online. It needs accurate information, professional presentation, strong visibility, competitive positioning and a trustworthy reputation.</p>
              <p>HM Services helps property owners manage these important areas through practical hospitality and digital solutions — combining real hospitality know-how with the booking platforms and digital tools that drive discovery today.</p>
            </div>
          </Reveal>
          <Reveal variant="right" className="overflow-hidden rounded-3xl shadow-float-lg">
            <img src={IMG.reception} alt="Hotel reception" className="h-full w-full object-cover" loading="lazy" />
          </Reveal>
        </div>
      </section>

      {/* Founder */}
      <section className="bg-mist py-24 lg:py-32" data-testid="founder-section">
        <div className="mx-auto grid max-w-6xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <Reveal variant="left" className="overflow-hidden rounded-3xl shadow-float-lg">
            <img src={IMG.founder} alt={`${site.founder.name}, ${site.founder.role}`} className="aspect-[4/5] w-full object-cover" loading="lazy" />
          </Reveal>
          <Reveal>
            <span className="eyebrow text-ocean">Meet the Founder</span>
            <h2 className="mt-4 font-serif text-4xl font-bold text-navy">{site.founder.name}</h2>
            <p className="mt-1 text-lg font-medium text-ocean">{site.founder.role}</p>
            <p className="mt-6 text-base leading-relaxed text-slate-600">
              Hassan Ali is a hospitality professional with experience in hotel management, guest relations, front-office operations, customer service, team coordination and property management. Through HM Services, he combines practical hospitality experience with digital tools and booking platforms to help property owners improve their online presence and business performance.
            </p>
          </Reveal>
        </div>
      </section>

      <SecuritySection />
      <CTASection />
    </>
  );
}
